import styled from 'styled-components'

export default styled.div`
  color: #c2c7cc;
  font-weight: normal;
  align-self: center;
  margin-right: ${p => p.marginRight};
`
